import type { Screen } from '../../../shared/types';

export interface MappingStartupResumeState {
  authSatisfied: boolean;
  currentScreen: Screen;
  projectSetupCompleted: boolean;
  resumeIntoMappingRequested: boolean;
  reinitiatedWizard: boolean;
}

export function shouldResumeMappingAtStartup(
  state: MappingStartupResumeState
): boolean {
  if (!state.authSatisfied || state.currentScreen !== 'welcome') {
    return false;
  }

  return state.projectSetupCompleted
    && state.resumeIntoMappingRequested
    && !state.reinitiatedWizard;
}
